import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	rootTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	premiumPlanTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	standardPlanTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reverseTrialRootTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reverseTrialCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	rootTitle: {
		id: 'software-onboarding-quickstart.services.tasks.config.jsw.root-title.no-translate',
		defaultMessage: 'Quickstart',
		description: 'Initial title of Quickstart for software projects',
	},
	premiumPlanTitle: {
		id: 'onboarding-quickstart-core.services.tasks.config.jsw.premium-plan-title',
		defaultMessage: 'Included in your Premium plan',
		description: 'Quickstart title of "explore your premuim plan" page',
	},
	standardPlanTitle: {
		id: 'onboarding-quickstart-core.services.tasks.config.jsw.standard-plan-title',
		defaultMessage: 'Your Standard plan',
		description: 'Quickstart title of "explore your standard plan" page',
	},
	reverseTrialRootTitle: {
		id: 'onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-root-title',
		defaultMessage: 'Your 30-day Premium trial',
		description: 'Initial title of Quickstart for software projects on premium reverse trial',
	},
	reverseTrialCardTitle: {
		id: 'onboarding-quickstart-core.services.tasks.config.jsw.reverse-trial-card-title',
		defaultMessage: 'Included in your Premium trial',
		description: 'Quickstart title of "explore your premuim plan" page for reverse trial',
	},
});
